// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__C1nnN","upload":"Small_upload__28WaG","imageWrap":"Small_imageWrap__1n-bq","removeBtn":"Small_removeBtn__1wcP7"};